import PropTypes from 'prop-types';

import { InfoTooltip, MenuPanel } from 'components/simple';

export const SingleSelectFilterPanel = ({ filterValue, valueOptions, onChangeFilterModel }) => {
  const options = valueOptions.map((option) => ({
    key: option.label,
    label: option.label,
    selected: option.value === filterValue,
    onClick: () => onChangeFilterModel(option.value),
    endSlot: option.description ? <InfoTooltip titleText={option.description} placement="bottom-end" /> : null,
  }));

  return <MenuPanel options={options} />;
};

SingleSelectFilterPanel.propTypes = {
  onChangeFilterModel: PropTypes.func.isRequired,
  filterValue: PropTypes.string,
  valueOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      description: PropTypes.string,
    }),
  ).isRequired,
};
